// Importing other js files
document.addEventListener('DOMContentLoaded', function () {
  //svg 
  document.getElementById('svg-icons').innerHTML = SVG_SPRITE;
  //end svg


   //modal

   var modalBeginToggle = document.getElementById('modalBeginToggle');


   var modal = document.querySelector('.modal');

   var modalToggle = document.getElementsByClassName('modalToggle');

   for (var i = 0; i < modalToggle.length; ++i) {
       var item = modalToggle[i];  
       item.addEventListener('click', function(){

          modal.classList.add('active');

       });
   }

 
   var modalClose = document.getElementsByClassName('modal__close');

   for (var i = 0; i < modalClose.length; ++i) {
       var item = modalClose[i];  
       item.addEventListener('click', function(){
         modal.classList.remove('active');
         
       });
   }



   var modalBackDrop = document.querySelector('.modal__backdrop');

   modalBackDrop.addEventListener('click', function(){
     modal.classList.remove('active');
   });

   //end modal

   var toggleUnder18 = document.getElementById('toggleUnder18');
   var under18 = document.getElementById('under18');
   var above18 = document.getElementById('above18');


   toggleUnder18.addEventListener('click', function(){
    under18.classList.add('is-show');
    under18.classList.add('shake');

    setTimeout(function () {
      under18.classList.remove('shake');
    }, 1500);

  });

  above18.addEventListener('click', function(){
    under18.classList.remove('shake');
    under18.classList.remove('is-show');
  });



}, false);
window.SVG_SPRITE = '<?xml version="1.0" encoding="UTF-8"?><!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><symbol id="icon-heart" viewBox="0 0 24 22"><path d="M12 8.2c.2-1.1 1.5-6.2 5.4-6.2C19.6 2 22 3.6 22 7c0 3.9-3.6 8.5-10 12.6C5.6 15.5 2 10.9 2 7c0-3.5 2.4-5 4.6-5 3.9 0 5.1 5.1 5.4 6.2zM0 7c0 4.1 3.1 9.5 12 15 8.9-5.5 12-10.9 12-15 0-8-9.6-9-12-3.7C9.7-2 0-1 0 7z"/></symbol><symbol id="icon-location" viewBox="0 0 32 32"><path d="M16 0C10.477 0 6 4.477 6 10c0 10 10 22 10 22s10-12 10-22c0-5.523-4.477-10-10-10zm0 16a6 6 0 110-12 6 6 0 010 12z"/></symbol><symbol id="icon-x" viewBox="0 0 122.878 122.88"><path d="M1.426 8.313a4.87 4.87 0 016.886-6.886l53.127 53.127 53.127-53.127a4.87 4.87 0 116.887 6.886L68.324 61.439l53.128 53.128a4.87 4.87 0 01-6.887 6.886L61.438 68.326 8.312 121.453a4.868 4.868 0 11-6.886-6.886l53.127-53.128L1.426 8.313z"/></symbol></svg>';